<div class="banner" *ngIf="!!banner_.message && banner_.message !== ''"
     [class.success]="banner_.success"
     [class.error]="!banner_.success">
    <div class="icon-container"></div>
    <div class="text-container">{{ banner_.message }}</div>
</div>
